<template>
<header>
    キャンペーン
    <div class="h-left">
        <a @click="$router.push({name: 'campaign'})"><img src="~@/assets/images/icon02.svg" /></a>
    </div>
</header>
<div id="wrap">
    <!-- <div class="clearfix">
        <p class="real-day01">{{ campaignDetail ? campaignDetail.title : '' }}</p>
    </div> -->
    <div class="txt-area">
        <div v-html="campaignDetail">
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
} from "vuex"
import mixin from "@/mixin"
import CONSTANTS from "@/constants"
export default {
    mixins: [mixin],
    data: () => ({
        campaignDetail: null
    }),
    mounted() {
        this.getCampaignDetail()
    },
    computed: {
        ...mapGetters(["defaultToken"]),
    },
    methods: {
        getCampaignDetail() {
            this.$store.dispatch("profile/getCampaignDetail", {
                token: this.defaultToken,
                campaign_id: this.$route.query.campaign_id,
            }).then(data => {
                if (process.env.NODE_EN == 'production') {
                    data = data.replace(CONSTANTS.CAMPAIGN_URL_LIVE, CONSTANTS.CONTENT_URL_LIVE);
                } else {
                    data = data.replace(CONSTANTS.CAMPAIGN_URL_STG, CONSTANTS.CONTENT_URL_STG);
                }

                this.$store.dispatch("user/loadPage", data).then(res => {
                    this.campaignDetail = res
                }).catch(err => {
                    console.log(err)
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
};
</script>
